import { render, staticRenderFns } from "./ota.vue?vue&type=template&id=17b3efb4&"
import script from "./ota.vue?vue&type=script&lang=js&"
export * from "./ota.vue?vue&type=script&lang=js&"
import style0 from "./ota.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports